import { BrickContext, Brick, registerBrick } from 'olympe';

export default class CreateNumberArray extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {number} count
     * @param {function(Array)} setArray
     */
    update($, [a, b], [setArray]) {
        const list = [];
        let i = a;
        while (i <= b) {
            list.push(i);
            i++;
        }
        setArray(list);
    }
}

registerBrick('0192dca1de54bbf64330', CreateNumberArray);
